<!-- 微信关注扫码领红包 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goDrawer"
                    >新增微信关注扫码领红包</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="product">
                        <div class="flex-c">
                            {{ row.product ? row.product.product_name : "" }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="user_packet_sum_money">
                        <div class="flex-c">
                            {{
                                row.user_packet_sum_money
                                    ? row.user_packet_sum_money
                                    : 0
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="user_packet_count">
                        <Button @click="goCount(row)">{{
                            row.user_packet_count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div class="flex-c">
                            <i-switch
                                v-model="row.status"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeStatus(row, $event)"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost @click="goDrawer(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="80">
            <Form :model="formData" label-position="right" :label-width="150">
                <div class="form-title">金额设置</div>
                <FormItem label="红包模式：">
                    <Select
                        class="w300"
                        v-model="formData.mode"
                        clearable
                        filterable
                        placeholder="请选择红包模式"
                    >
                        <Option
                            v-for="item in modeList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="红包数量：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="formData.num"
                        placeholder="请输入红包数量"
                        ><span slot="append">个</span></Input
                    >
                </FormItem>
                <FormItem v-if="formData.mode == 1" label="每份红包金额：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="formData.money"
                        placeholder="请输入每份红包金额"
                        ><span slot="append">元</span></Input
                    >
                </FormItem>
                <FormItem v-if="formData.mode == 2" label="红包总金额：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="formData.money_sum"
                        placeholder="请输入红包总金额"
                        ><span slot="append">元</span></Input
                    >
                </FormItem>
                <div class="form-title">红包类型</div>
                <FormItem label="红包类型：">
                    <RadioGroup v-model="formData.type">
                        <Radio class="mr24" label="1">普通红包</Radio>
                        <Radio class="mr24" label="2">导购红包</Radio>
                    </RadioGroup>
                </FormItem>
                <template v-if="formData.type == 2">
                    <FormItem label="自动发放：">
                        <i-switch
                            v-model="formData.is_auto"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                            @on-change="changeIsAuto"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="导购员名单：">
                        <Button @click="goShopList">导购员列表</Button>
                    </FormItem>
                </template>
                <template v-if="formData.is_auto != 1">
                    <div class="form-title">产品设置</div>
                    <FormItem label="产品批次：">
                        <Select
                            class="w300"
                            v-model="formData.batch_id"
                            clearable
                            filterable
                            placeholder="请选择产品批次"
                        >
                            <Option
                                v-for="item in batchList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.batch_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="产品名称：">
                        <Select
                            class="w300"
                            v-model="formData.product_id"
                            clearable
                            filterable
                            placeholder="请选择产品名称"
                        >
                            <Option
                                v-for="item in productList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.product_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="产品代理商：">
                        <Select
                            class="w300"
                            v-model="formData.agent_id"
                            clearable
                            filterable
                            placeholder="请选择产品代理商"
                        >
                            <Option
                                v-for="item in agentList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.agent_name }}</Option
                            >
                        </Select>
                    </FormItem>
                </template>
                <div class="form-title">样式设置</div>
                <div class="flex1">
                    <FormItem label="LOGO设置: ">
                        <div class="flex1">
                            <div
                                class="upload-container mr12"
                                @click="openModal(1)"
                            >
                                <Icon
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                                <div>尺寸55px 55px</div>
                            </div>
                            <div v-if="formData.logo" class="img-container">
                                <img class="wh100" :src="formData.show_logo" />
                                <Icon
                                    class="img-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="goDelLogo"
                                />
                            </div>
                        </div>
                    </FormItem>
                    <FormItem label="红包样式：">
                        <div class="flex1">
                            <div
                                class="upload-container mr12"
                                @click="openModal(2)"
                            >
                                <Icon
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                                <div>尺寸300px 430px</div>
                            </div>
                            <div
                                v-if="formData.style_url"
                                class="img-container"
                            >
                                <img class="wh100" :src="formData.show_style" />
                                <Icon
                                    class="img-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="goDelStyle"
                                />
                            </div>
                        </div>
                    </FormItem>
                </div>
                <FormItem label="红包文字1设置: ">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.word1"
                        placeholder="请输入红包文字"
                    ></Input>
                </FormItem>
                <FormItem label="红包文字2设置: ">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.word2"
                        placeholder="请输入红包文字"
                    ></Input>
                </FormItem>
                <FormItem label="红包文字3设置: ">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.word3"
                        placeholder="请输入红包文字"
                    ></Input>
                </FormItem>
                <div class="footer">
                    <Button @click="cancelForm">取消</Button>
                    <Button
                        class="theme-bc ml24 theme-default-color"
                        @click="submitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </Drawer>
        <!-- 参与人数 -->
        <Drawer v-model="countDrawer" title="参与人数" width="80">
            <div>
                <div class="flex-sb mb24">
                    <div>
                        <Select
                            class="w200 mr24"
                            v-model="pageCount.pay_status"
                            clearable
                            filterable
                            placeholder="请选择状态"
                        >
                            <Option
                                v-for="item in payStatusList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </div>
                    <Button
                        class="theme-bc theme-default-color"
                        icon="ios-search"
                        @click="goSearch"
                        >确认搜索</Button
                    >
                </div>
                <Table :columns="columnCount" :data="dataCount" border>
                    <template slot-scope="{ row }" slot="pay_status">
                        <div v-if="row.pay_status == 0">付款中</div>
                        <div v-if="row.pay_status == 1">发放成功</div>
                        <div v-if="row.pay_status == 2">发放失败</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                v-if="row.pay_status == 2"
                                type="primary"
                                ghost
                                @click="goRefresh(row)"
                                >重新发放</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageCount.page"
                        :page-size="pageCount.limit"
                        :total="totalCount"
                        show-elevator
                        show-total
                        @on-change="pageChangeCount"
                    />
                </div>
            </div>
        </Drawer>
        <!-- 导购员列表 -->
        <Drawer v-model="shopDrawer" title="导购员列表" width="60">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goAddShop(1)"
                    >新增导购员</Button
                >
                <Table :columns="columnShop" :data="dataShop" border>
                    <template slot-scope="{ row }" slot="name">
                        <div>
                            {{
                                row.guide
                                    ? row.guide.customer
                                        ? row.guide.customer.name
                                        : ""
                                    : ""
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="phone">
                        <div>
                            {{
                                row.guide
                                    ? row.guide.customer
                                        ? row.guide.customer.phone
                                        : ""
                                    : ""
                            }}
                        </div>
                    </template>
                    <template
                        v-if="is_auto_value"
                        slot-scope="{ row }"
                        slot="qrcode_count"
                    >
                        <Button @click="goAddShop(2, row)">{{
                            row.qrcode_count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-c">
                            <Button type="error" ghost @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageShop.page"
                        :page-size="pageShop.limit"
                        :total="totalShop"
                        show-elevator
                        show-total
                        @on-change="pageChangeShop"
                    />
                </div>
                <div class="footer"></div>
            </div>
        </Drawer>
        <!-- 新增导购员 -->
        <Drawer v-model="addShopDrawer" :title="add_shop_title" width="60">
            <div>
                <Form
                    :model="form_add_shop"
                    label-position="right"
                    :label-width="100"
                >
                    <template v-if="shop_value == 1">
                        <FormItem label="选择分类：">
                            <Select
                                class="w300"
                                v-model="form_add_shop.guide_type_id"
                                clearable
                                filterable
                                placeholder="请选择分类"
                                @on-change="goChangeType"
                            >
                                <Option
                                    v-for="item in typeList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                        <FormItem
                            v-if="form_add_shop.guide_type_id"
                            label="选择导购员："
                        >
                            <Select
                                class="w300"
                                v-model="form_add_shop.guide_id"
                                clearable
                                filterable
                                placeholder="请选择导购员"
                            >
                                <Option
                                    v-for="item in guideList"
                                    :value="item.id"
                                    :key="item.id"
                                    :label="`${item.customer.name} ${item.customer.phone}`"
                                />
                            </Select>
                        </FormItem>
                    </template>
                    <template v-if="is_auto_value">
                        <FormItem label="ID号段：">
                            <div class="flex1">
                                <Input
                                    class="w200 mr24"
                                    type="number"
                                    v-model="form_add_shop.start_id"
                                    placeholder="请输入起始ID"
                                ></Input>
                                <div style="min-width: 20px">---</div>
                                <Input
                                    class="w200 ml24 mr24"
                                    type="number"
                                    v-model="form_add_shop.end_id"
                                    placeholder="请输入截止ID"
                                ></Input>
                                <Button
                                    class="theme-bc theme-default-color"
                                    @click="goInsert"
                                    >插入</Button
                                >
                            </div>
                        </FormItem>
                        <FormItem label="录入产品码：">
                            <div style="display: flex; align-items: end">
                                <Input
                                    @input="handleInputChange"
                                    class="w30 mr24"
                                    type="textarea"
                                    v-model="form_add_shop.qrcode_number"
                                    :autosize="{ minRows: 10 }"
                                    placeholder="一行一个"
                                ></Input>
                                <div class="flex1">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                            cursor: pointer;
                                        "
                                        @click="setNull"
                                    >
                                        <img
                                            src="@/assets/blank.png"
                                            style="
                                                display: block;
                                                margin-right: 6px;
                                            "
                                        />
                                        <div>置空</div>
                                    </div>
                                </div>
                            </div>
                        </FormItem>
                    </template>
                </Form>
                <div class="footer">
                    <Button @click="cancelAddShop">取消</Button>
                    <Button
                        class="theme-bc ml24 theme-default-color"
                        @click="submitAddShop"
                        >确定</Button
                    >
                </div>
            </div>
        </Drawer>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    assembly_wxpacket_list,
    assembly_wxpacket_status,
    assembly_wxpacket_delete,
    assembly_wxpacket_info,
    assembly_wxpacket_save,
    assembly_wxpacket_prize,
    assembly_wxpacket_refresh,
    product_select,
    batch_select,
    agent_select,
    shopping_wxpacket,
    shopping_wxpacket_save,
    shopping_wxpacket_delete,
    shopping_wxpacket_add_qrcode,
    shopping_wxpacket_search_qrcode,
    shopping_wxpacket_infos,
    shopping_type_select,
    shopping_select,
} from "@/api/index";
import VueQr from "vue-qr";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { VueQr, pictureLibrary },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "活动产品", slot: "product", align: "center" },
                { title: "活动总金额", key: "money_sum", align: "center" },
                {
                    title: "已瓜分金额",
                    slot: "user_packet_sum_money",
                    align: "center",
                },
                {
                    title: "参与人数",
                    slot: "user_packet_count",
                    align: "center",
                },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            drawers: false,
            drawerTitle: "",
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                mode: 1,
                num: "",
                money: "0.3",
                money_sum: "",
                logo: "",
                style_url: "",
                word1: "",
                word2: "",
                word3: "",
                id: "",
                show_logo: "",
                show_style: "",
                type: "1",
                is_auto: 0,
            },
            modeList: [
                { id: 1, name: "固定红包" },
                { id: 2, name: "随机红包" },
            ],
            batchList: [],
            productList: [],
            agentList: [],
            countDrawer: false,
            pageCount: {
                page: 1,
                limit: 10,
                packet_id: "",
                pay_status: -1,
            },
            totalCount: 0,
            columnCount: [
                { type: "index", width: 60, align: "center" },
                { title: "金额（元）", key: "money", align: "center" },
                { title: "兑换码", key: "qrcode_id", align: "center" }, 
                { title: "领取时间", key: "created_at", align: "center" },
                { title: "发放状态", slot: "pay_status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataCount: [],
            payStatusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "付款中" },
                { id: 1, name: "成功" },
                { id: 2, name: "失败" },
            ],
            shopDrawer: false,
            pageShop: {
                page: 1,
                limit: 10,
                packet_id: "",
            },
            totalShop: 0,
            columnShop: [],
            dataShop: [],
            addShopDrawer: false,
            add_shop_title: "",
            form_add_shop: {
                qrcode_number_array: [],
                qrcode_number: "",
                guide_type_id: "",
                guide_id: "",
                packet_id: "",
                start_id: "",
                end_id: "",
            },
            typeList: [],
            guideList: [],
            is_auto_value: false,
            shop_value: 1,
        };
    },
    mounted() {
        this.getList();
        this.getProductSelect();
        this.getBatchSelect();
        this.getagentSelect();
        this.getShoppingTypeSelect();
    },
    methods: {
        setNull() {
            this.form_add_shop.qrcode_number = "";
            this.formData.qrcode_number_array = [];
        },
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_logo = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.logo = param2[i];
                }
                this.$Message.destroy();
            } else if (this.imgtype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_style = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.style_url = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            assembly_wxpacket_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 下拉
        getProductSelect() {
            product_select()
                .then((res) => {
                    this.productList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getBatchSelect() {
            batch_select()
                .then((res) => {
                    this.batchList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getShoppingTypeSelect() {
            shopping_type_select()
                .then((res) => {
                    this.typeList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getShoppingSelect(e) {
            shopping_select({ type_id: e })
                .then((res) => {
                    this.guideList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getagentSelect() {
            agent_select()
                .then((res) => {
                    this.agentList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Drawer
        goDrawer(row) {
            if (row.id) {
                this.drawerTitle = "编辑活动红包";
                assembly_wxpacket_info({ id: row.id })
                    .then((res) => {
                        this.formData.batch_id = res.data.batch_id;
                        this.formData.product_id = res.data.product_id;
                        this.formData.agent_id = res.data.agent_id;
                        this.formData.mode = res.data.mode;
                        this.formData.num = res.data.num;
                        this.formData.money = res.data.money;
                        this.formData.money_sum = res.data.money_sum;
                        this.formData.logo = res.data.logo;
                        this.formData.style_url = res.data.style_url;
                        this.formData.word1 = res.data.word1;
                        this.formData.word2 = res.data.word2;
                        this.formData.word3 = res.data.word3;
                        this.formData.id = res.data.id;
                        this.formData.show_logo = res.data.show_logo;
                        this.formData.show_style = res.data.show_style;
                        this.formData.type = String(res?.data?.type || "");
                        this.formData.is_auto = res.data.is_auto;
                    })
                    .catch((err) => {
                        this.$Message.error(err.msg);
                    });
            } else {
                this.drawerTitle = "新增活动红包";
                this.formData.batch_id = "";
                this.formData.product_id = "";
                this.formData.agent_id = "";
                this.formData.mode = 1;
                this.formData.num = "";
                this.formData.money = "0.3";
                this.formData.money_sum = "";
                this.formData.logo = "";
                this.formData.style_url = "";
                this.formData.word1 = "";
                this.formData.word2 = "";
                this.formData.word3 = "";
                this.formData.id = "";
                this.formData.show_logo = "";
                this.formData.show_style = "";
                this.formData.type = "1";
                this.formData.is_auto = 0;
            }
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        cancelForm() {
            this.drawers = false;
        },
        // 确定(提交表单)
        submitForm() {
            assembly_wxpacket_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.drawers = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        getShopList() {
            shopping_wxpacket(this.pageShop)
                .then((res) => {
                    this.dataShop = res.data.data;
                    this.totalShop = res.data.total;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goDel(index, row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 1) {
                        assembly_wxpacket_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    } else if (index == 2) {
                        shopping_wxpacket_delete({ id: row.id })
                            .then((res) => {
                                this.getShopList();
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        changeStatus(row, e) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    let data = {
                        id: row.id,
                        status: e,
                    };
                    assembly_wxpacket_status(data)
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        // 红包领取记录
        getAssemblyWxpacketPrize() {
            assembly_wxpacket_prize(this.pageCount)
                .then((res) => {
                    this.dataCount = res.data.data;
                    this.totalCount = res.data.total;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        pageChangeCount(index) {
            this.pageCount.page = index;
            this.getAssemblyWxpacketPrize();
        },
        pageChangeShop(index) {
            this.pageShop.page = index;
            this.getShopList();
        },
        goSearch() {
            this.pageCount.page = 1;
            this.getAssemblyWxpacketPrize();
        },
        goCount(row) {
            this.pageCount.packet_id = row.id;
            this.getAssemblyWxpacketPrize();
            this.countDrawer = true;
        },
        goRefresh(row) {
            assembly_wxpacket_refresh({ id: row.id })
                .then((res) => {
                    this.getAssemblyWxpacketPrize();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        changeIsAuto(e) {
            this.formData.is_auto = e;
        },
        // 删除图片
        goDelLogo() {
            this.formData.show_logo = "";
            this.formData.logo = "";
        },
        goDelStyle() {
            this.formData.show_style = "";
            this.formData.style_url = "";
        },
        goShopList() {
            if (this.formData.id) {
                this.pageShop.packet_id = this.formData.id;
                this.getShopList();
            } else {
                assembly_wxpacket_save(this.formData)
                    .then((res) => {
                        this.pageShop.packet_id = res.data;
                        this.getShopList();
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
            if (this.formData.is_auto == 1) {
                this.is_auto_value = true;
                this.columnShop = [
                    { type: "index", width: 60, align: "center" },
                    { title: "导购名称", slot: "name", align: "center" },
                    { title: "手机号", slot: "phone", align: "center" },
                    {
                        title: "绑定溯源码",
                        slot: "qrcode_count",
                        align: "center",
                    },
                    {
                        title: "操作",
                        slot: "operate",
                        align: "center",
                        width: "100px",
                    },
                ];
            } else {
                this.is_auto_value = false;
                this.columnShop = [
                    { type: "index", width: 60, align: "center" },
                    { title: "导购名称", slot: "name", align: "center" },
                    { title: "手机号", slot: "phone", align: "center" },
                    {
                        title: "操作",
                        slot: "operate",
                        align: "center",
                        width: "100px",
                    },
                ];
            }
            setTimeout(() => {
                this.shopDrawer = true;
            }, 300);
        },
        goAddShop(i, row) {
            this.shop_value = i;
            if (i == 1) {
                this.add_shop_title = "新增导购员";
                this.form_add_shop.qrcode_number_array = [];
                this.form_add_shop.qrcode_number = "";
                this.form_add_shop.guide_type_id = "";
                this.form_add_shop.guide_id = "";
                this.form_add_shop.start_id = "";
                this.form_add_shop.end_id = "";
            } else {
                this.add_shop_title = "绑定溯源码";
                var data = {
                    guide_id: row.guide_id,
                    packet_id: this.formData.id,
                };
                this.form_add_shop.guide_id = row.guide_id;
                shopping_wxpacket_infos(data)
                    .then((res) => {
                        this.form_add_shop.qrcode_number = res.data.join("\n");
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
            setTimeout(() => {
                this.addShopDrawer = true;
            }, 300);
        },
        // 新增导购员取消按钮
        cancelAddShop() {
            this.addShopDrawer = false;
        },
        // 新增导购员确定按钮
        submitAddShop() {
            this.form_add_shop.qrcode_number_array =
                this.form_add_shop.qrcode_number
                    .split("\n")
                    .map((item) => (item === "" ? null : item)) // 将空字符串转为 null
                    .filter((item) => item !== null); // 过滤掉所有 null 值
            if (this.shop_value == 1) {
                var data = {
                    guide_type_id: this.form_add_shop.guide_type_id,
                    guide_id: this.form_add_shop.guide_id,
                    packet_id: this.formData.id,
                    qrcode_number: this.form_add_shop.qrcode_number_array,
                };
                shopping_wxpacket_save(data)
                    .then((res) => {
                        this.getShopList();
                        this.addShopDrawer = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else {
                var data = {
                    guide_id: this.form_add_shop.guide_id,
                    packet_id: this.formData.id,
                    qrcode_number: this.form_add_shop.qrcode_number_array,
                };
                shopping_wxpacket_add_qrcode(data)
                    .then((res) => {
                        this.getShopList();
                        this.addShopDrawer = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        goInsert() {
            var data = {
                start_id: this.form_add_shop.start_id,
                end_id: this.form_add_shop.end_id,
            };
            shopping_wxpacket_search_qrcode(data)
                .then((res) => {
                    console.log("res", res.data);
                    var value;
                    value = res.data
                        .map((item) => item) // 提取所有值
                        .filter((code) => code && code.trim()) // 过滤空值
                        .filter(
                            (code, index, self) => self.indexOf(code) === index
                        ) // 去重
                        .join("\n");
                    if (this.form_add_shop.qrcode_number) {
                        this.form_add_shop.qrcode_number += "\n" + value;
                    } else {
                        this.form_add_shop.qrcode_number += value;
                    }
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        handleInputChange(e) {
            // 获取当前输入框的值
            const inputValue = e.target ? e.target.value : e;
            // 按换行符分割为数组（处理多行输入）
            const lines = inputValue.split("\n");
            // 用于存储处理后的所有码
            const allCodes = [];
            // 匹配完整URL的正则表达式（支持https/http）
            const urlPattern = /https?:\/\/[^\s?]+\?q=([\w]+)/g;
            // 处理每一行数据
            lines.forEach((line) => {
                // 处理行内的所有URL
                let match;
                let lastIndex = 0;
                const results = [];
                // 1. 提取行内所有URL的q参数值
                while ((match = urlPattern.exec(line)) !== null) {
                    // 添加URL前可能存在的非URL文本
                    if (match.index > lastIndex) {
                        const textBefore = line
                            .substring(lastIndex, match.index)
                            .trim();
                        if (textBefore) results.push(textBefore);
                    }
                    // 添加提取的q参数值
                    results.push(match[1]);
                    // 更新lastIndex
                    lastIndex = match.index + match[0].length;
                }
                // 2. 添加最后一个URL后的剩余文本
                if (lastIndex < line.length) {
                    const textAfter = line.substring(lastIndex).trim();
                    if (textAfter) results.push(textAfter);
                }
                // 3. 处理没有URL的直接输入码
                if (results.length === 0) {
                    const directCodeMatch = line.match(/^([\w\-.]+)\s*$/);
                    if (directCodeMatch) {
                        results.push(directCodeMatch[1]);
                    } else {
                        results.push(line); // 保留原始行内容
                    }
                }
                // 收集当前行的所有结果
                allCodes.push(...results);
            });
            // 更新v-model绑定的数据（去除空行）
            this.form_add_shop.qrcode_number = allCodes
                .filter((code) => code.trim() !== "")
                .join("\n");
        },
        goChangeType(e) {
            this.getShoppingSelect(e);
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.form-title {
    margin-bottom: 24px;
    color: #484e66;
    font-weight: 600;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.footer {
    margin: 24px 0 0 0;
    text-align: right;
}
.upload-container {
    width: 100px;
    height: 100px;
    background-color: #fff;
    border: 1px dashed #9fa5bb;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.img-container {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    position: relative;
}
.wh100 {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.flex1 {
    display: flex;
}
.img-del {
    position: absolute;
    top: -6px;
    right: -6px;
    cursor: pointer;
}
.w30 {
    width: 30vw;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
/* RadioGroup */
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border: 2px solid #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #fff;
}
::v-deep .ivu-radio-inner {
    transition: none;
}
</style>